export function randombytes(out, n) {
  const crypto = globalThis.crypto || globalThis.msCrypto;
  if (!crypto?.getRandomValues) {
    throw new Error('No secure random number generator available');
  }
  const QUOTA = 65536; // limit for QuotaExceededException

  for (let i = 0; i < n; i += QUOTA) {
    crypto.getRandomValues(
      new Uint8Array(out.buffer, i + out.byteOffset, Math.min(n - i, QUOTA))
    );
  }
}
